import { z } from 'zod/v3';

export const CitationSearchSchema = z.object({
  query: z.string(),
});

export type CitationSearch = z.infer<typeof CitationSearchSchema>;

export const CitationSchema = z.object({
  id: z.string().optional(),
  title: z.string().optional(),
  slug: z.string().optional().describe("The canonical slug for URL generation"),
  topicId: z.string().optional().describe("The topic ID for navigation"),
  docId: z.string().optional().describe("The document ID for navigation"),
  icon: z.string().optional(),
  sourceType: z.string().optional(),
  score: z.number().optional(),
  content: z.string().optional(),
  startIndex: z.number().optional(),
  endIndex: z.number().optional(),
  order: z.number().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export type Citation = z.infer<typeof CitationSchema>;
